export class UrlModel {
  public url: string;

  constructor(params: UrlModel) {
    this.url = params.url;
  }

  public static fromCartV1(url: string) {
    return new UrlModel({
      url,
    });
  }

  // eslint-disable-next-line sonarjs/no-identical-functions
  public static fromCartV2(url: string): UrlModel {
    return new UrlModel({
      url,
    });
  }
}
